<head>
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
        integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw=="
        crossorigin="anonymous" referrerpolicy="no-referrer" />
</head>

<nav aria-label="breadcrumb">
    <ol class="breadcrumb padding-left bottomLine"
        style="margin-block-start: 0px !important;margin-block-end: 4px !important;margin-inline-start: 0px !important;margin-inline-end: 0px !important;padding-inline-start: 6px !important;">
        <li class="breadcrumb-item breamcrumb-text">{{firstLevel}}</li>
        <li class="breadcrumb-item breamcrumb-text" [ngClass]="'lastNode'"><a>{{secondLevel}}</a></li>
    </ol>
</nav>

<div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<div class="menu-container">
    <div class="row menu-row-container">
        <div class="col-sm-6 gridName-container" style="margin-bottom: 5px;">
            <span class="gridName">{{operation}}</span>
        </div>
    </div>
</div>
<div class="table-container" *ngIf="operation == 'Upgrade'">
    <div class="row" style="margin-top: 1%;">
        <div class="col-md-11">
            <mat-radio-group aria-label="Select an option" [(ngModel)]="dataFrom" (change)="onTypeChanged(dataFrom)">
                <mat-radio-button value="specificOrg">Specific Organization</mat-radio-button>
                <mat-radio-button value="allChildOrgs">All Child Organizations</mat-radio-button>
            </mat-radio-group>
        </div>
    </div>
</div>
<div class="table-container" *ngIf="dataFrom != null">

    <div id="header-container" class="row" style="height: auto;">
        <div class="col-md-1">

        </div>
        <div class="col-md-6">

            <div class="row" [hidden]="dataFrom == 'allChildOrgs'">
                <div class="col-md-4"><label>Target Organization ID</label></div>
                <div class="col-md-6">
                    <input type="text" class="input-filed-continers" [(ngModel)]="orgData.targetOrgId">
                </div>
            </div>
            <br [hidden]="dataFrom == 'allChildOrgs'">
            <div class="row" [hidden]="dataFrom == 'allChildOrgs'">
                <div class="col-md-4"><label>Target Organization Short Name</label></div>
                <div class="col-md-8">
                    <input type="text" class="input-filed-continers" [(ngModel)]="orgData.targetOrgShortName">
                </div>
            </div>
            <br [hidden]="dataFrom == 'allChildOrgs'">
            <div class="row" *ngIf="operation == 'Create'">
                <div class="col-md-4"><label>Target Organization Long Name</label></div>
                <div class="col-md-8">
                    <input type="text" class="input-filed-continers" [(ngModel)]="orgData.targetOrgLongName">
                </div>
            </div>
            <br *ngIf="operation == 'Create'">
            <div class="row">
                <div class="col-md-4"><label>Release Version</label></div>
                <div class="col-md-6">
                    <!-- <ng-multiselect-dropdown id="documentIssuanceType" class="multiselect-container" [(ngModel)]="selectedReleaseVersion"
                    [settings]="singleSelectDropdownSetting" [data]="dropdownForRelaseversion"
                    (onSelect)="onVersionSelect($event)" (onDeSelect)="onVersionRemoved($event)">
                    </ng-multiselect-dropdown> -->
                    <mat-select matInput placeholder="Select" id="documentIssuanceType"
                        [(ngModel)]="selectedReleaseVersion" (closed)="releaseVersionsearchTxt=''"
                        (click)="focusmethod('releaseVersionfocusSearch')">
                        <input type="search" id="releaseVersionfocusSearch" class="dropdownsearchstyle"
                            [(ngModel)]="releaseVersionsearchTxt" matInput placeholder="Search">
                        <mat-option class="unselectStyle" [value]="null"
                            (onSelectionChange)="onVersionSelect($event,null);">Un-select</mat-option>
                        <mat-option
                            *ngFor="let item of dropdownForRelaseversion | assessmentSearch :releaseVersionsearchTxt"
                            (onSelectionChange)="onVersionSelect($event,item)" [value]="item.valueExp">
                            {{ item.displayExp }}
                        </mat-option>
                    </mat-select>
                </div>
            </div>
            <br>
            <div class="row" *ngIf="operation == 'Create'">
                <div class="col-md-4"><label>Application Launch URL</label></div>
                <div class="col-md-8">
                    <input type="text" class="input-filed-continers" [(ngModel)]="orgData.applicationLaunchUrl">
                </div>
            </div>
            <br *ngIf="operation == 'Create'">
            <div class="row" *ngIf="operation == 'Create'">
                <div class="col-md-4"><label>Target Organization System Admin Email ID</label></div>
                <div class="col-md-8">
                    <input type="text" class="input-filed-continers" [(ngModel)]="orgData.targetOrgSysadminEmailId">
                </div>
            </div>
            <br *ngIf="operation == 'Create'">
            <div class="row" *ngIf="operation == 'Create'">
                <div class="col-md-4"><label>Timezone</label></div>
                <div class="col-md-6">
                    <!-- <ng-multiselect-dropdown class="multiselect-container"
                    [(ngModel)]="selectedTimezoneValue" [settings]="singleSelectDropdownSetting" [data]="timezoneDropdown"
                    (onSelect)="onTimezoneSelect($event)" (onDeSelect)="onTimezoneRemoved($event)">
                  </ng-multiselect-dropdown> -->
                    <mat-select matInput placeholder="Select" id="documentIssuanceType"
                        [(ngModel)]="selectedTimezoneValue" (closed)="timezonesearchTxt=''"
                        (click)="focusmethod('timezonefocusSearch')">
                        <input type="search" id="timezonefocusSearch" class="dropdownsearchstyle"
                            [(ngModel)]="timezonesearchTxt" matInput placeholder="Search">
                        <mat-option class="unselectStyle" [value]="null"
                            (onSelectionChange)="onTimezoneSelect($event,null);">Un-select</mat-option>
                        <mat-option *ngFor="let item of timezoneDropdown | assessmentSearch :timezonesearchTxt"
                            (onSelectionChange)="onTimezoneSelect($event,item)" [value]="item.valueExp">
                            {{ item.displayExp }}
                        </mat-option>
                    </mat-select>
                </div>
            </div>
            <br *ngIf="operation == 'Create'">
            <div class="row">
                <div class="button-continer" mat-dialog-actions class="btn-align" style="display: block;">
                    <button mat-stroked-button class="addButton" (click)="createOrgFunc()">
                        <i class="fa fa-save"></i> {{operation}}
                    </button>

                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #confirmationPopup>
    <div class="ng-template-container">
        <div class="page-loading-shade" *ngIf="isProcessing">
            <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
        </div>
        <button class="close close-button" (click)="okForConfirmation()" mat-button><i
                class="fa popupClose">&#xf00d;</i></button>
        <!-- <h2 mat-dialog-title class="close-button">ONE-<span style="color:gold;">QMS</span></h2> -->

        <div mat-dialog-title>
            <label class="popupTitle">Confirmation</label>
            <label class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
        </div>
        <div style="margin: 10px;">
            <div>
                <div class="row">
                    <div class="col-md-12 text-center">
                        <pre *ngIf="resultType =='S'"
                            style="color: green;font-size: inherit;font-family: inherit;">{{resultMsg}}</pre>
                        <pre *ngIf="resultType =='E'"
                            style="color: red;font-size: inherit;font-family: inherit;">{{resultMsg}}</pre>
                    </div>

                </div>
            </div>
        </div>
        <div class="button-continer" mat-dialog-actions class="btn-align">
            <button mat-stroked-button class="addButton" (click)="okForConfirmation()">
                OK
            </button>
        </div>
    </div>
</ng-template>